import ShortenedTitle from "components/General-UI/ShortenedTitle";
import EfficeLink from "components/Home/MainContent/Text/AddPeople/InvitePeopleMain/EfficeLink/EfficeLink";
import React from "react";
// import { useSelector } from "react-redux";
// import { selectCurrentUserAttributes } from "slices/authSlice";
// import {
//   selectCurrentActiveEffice,
//   selectCurrentActiveType,
// } from "slices/sharedSelectors";

const InvitePeopleMain = ({ currentPermissionsEffice }) => {
  // const currentActiveEffice = useSelector(selectCurrentActiveEffice);
  // const myId = useSelector(selectCurrentUserAttributes).id;
  // const currentActiveType = useSelector(selectCurrentActiveType);

  return (
    <div className="invite-people-main">
      <p className="no-select">
        Only people with a link can become official members of&nbsp;
        <ShortenedTitle
          maxChars={50}
          title={currentPermissionsEffice.content}
        />
        . Links last 7 days by default, but can be disabled anytime.
      </p>
      <EfficeLink
        effId={currentPermissionsEffice.id}
        content={currentPermissionsEffice.content}
      />
    </div>
  );
};

export default InvitePeopleMain;
